import formatDistance from 'date-fns/esm/locale/ja/_lib/formatDistance/index.js';
import formatLong from 'date-fns/esm/locale/ja/_lib/formatLong/index.js';
import formatRelative from 'date-fns/esm/locale/ja/_lib/formatRelative/index.js';
import localize from 'date-fns/esm/locale/ja/_lib/localize/index.js';
import match from 'date-fns/esm/locale/ja/_lib/match/index.js';
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */

// Clone by `\node_modules\date-fns\esm\locale\ja\index.js`

var locale = {
  code: 'ja',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0,
    /* Sunday */
    firstWeekContainsDate: 1,
  },
};
export default locale;
